import { InitialState } from "../slices/models";

export const dataListaPedidosReducer = (state: InitialState, action: any) => {
  const { payload } = action;
  state.dataListaPedidos.data = payload.pedidos || [];
  state.dataListaPedidos.isLoading = false;
  state.dataListaPedidos.error = null;

  state.dataListaPedidos.requestGetParams = {
    ...action.meta.arg,
  };

  state.dataListaPedidos.pagination = {
    page: action.meta.arg.pagina,
    rowsPerPage: action.meta.arg.itensPorPagina,
    totalPages: action.payload.dadosPaginacao.totalPaginas,
    totalItems: action.payload.dadosPaginacao.totalRegistros,
  };
};
